<template>
  <div class="Thanks4Reg">
    <h1>Vielen Dank für die Registrierung, {{fetchUsername}}</h1>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {},
  computed: {
    fetchUsername() {
      return this.$store.state.firstName;
    }
  },
  created() {
    setTimeout(() => {
      this.$router.push("/");
    }, 1000);
  }
};
</script>

<style>
.Thanks4Reg {
  text-align: center;
  opacity: 0.85;
  filter: alpha(opacity=85);
  background-color: white;
  width: 80%;
  margin: 5% auto 0% auto;
  border: 2px solid black;
  border-radius: 5px; 
}
</style>
